<template>
  <div class="app">
    <h1>{{ title }}</h1>
    <Header :activeIndex="'9'" />

    <main class="margintop">
      <nav class="tiaozhuan" aria-label="面包屑导航">
        <router-link to="/" class="crumb-link">首页</router-link>
        <span class="crumb-sep">/</span>
        <router-link to="/xueyuan" class="crumb-link">老板学院</router-link>
        <span class="crumb-sep">/</span>
        <span class="crumb-current">知识详情</span>
      </nav>

      <div class="titlecss">{{ title }}</div>

      <article style="margin-left: auto; margin-right: auto">
        <div v-html="formattedContent" style="text-align: left"></div>
      </article>

      <div class="tagline" v-if="beforefont !== 'null' && beforefont !== null">
        <span class="tagline-label">关键词</span>
        <span class="tagline-text">{{ beforefont }}</span>
      </div>

      <div class="nav-prev-next">
        <div class="nav-card prev"
             v-if="previousId != 'null' && previousId != 0"
             @click="fetchPathPreviousId(previousId)">
          <div class="nav-card-label"><span class="nav-arrow">←</span>上一篇</div>
          <div class="nav-card-title">{{ previousTitle }}</div>
        </div>

        <div class="nav-card next"
             v-if="nextId != 'null' && nextId != 0"
             @click="fetchPathNextId(nextId)">
          <div class="nav-card-label">下一篇<span class="nav-arrow">→</span></div>
          <div class="nav-card-title">{{ nextTitle }}</div>
        </div>
      </div>

      <div class="action-bar">
        <button class="action-btn btn-back" @click="pathIndex">
          <span class="action-btn-icon">↩</span>返回首页
        </button>
        <button class="action-btn btn-share" @click="shareToggle = !shareToggle">
          <span class="action-btn-icon">⊕</span>分享本文
        </button>
      </div>

      <div class="share-card" v-show="shareToggle">
        <div class="share-card-header">
          <span class="share-card-title">分享本文</span>
        </div>
        <div class="share-card-body">
          <img loading="lazy" id="shareImg" class="share-qrcode" alt="分享页面二维码" />
        </div>
        <div class="share-card-tip">使用微信扫一扫，分享给好友</div>
      </div>

      <div style="margin-bottom: 50px"></div>
    </main>

    <Footer />
  </div>
</template>

<script src="https://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import wx from "weixin-js-sdk";
import { getNewsDetail, getNewsSibling } from "@/api/news";
import { getWechatSignature, generateShareCode } from "@/api/wechat";
export default {
  name: "xinwen",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      formattedContent: "",
      title: "",
      beforefont: "",
      image: "https://mingqicaiwu.com:9001/mingqi/thumbnail.jpg",
      id: 0,
      previousId: 0,
      previousTitle: "",
      nextId: 0,
      nextTitle: "",
      shareImg: "../assets/img/logo.jpg",
      shareDesc: "",
      shareImgdiyi: "",
      shareLink: "",
      isWeChat: false,
      appId: "wxea5602b03d0afffb",
      isMobile: true,
      shareToggle: false,

    };
  },
  mounted() {
    window.scrollTo(0, 0);
    // console.log(this.$root.showData.showData);
    this.$root.showData.showData = false;
    this.checkScreenSize(); // 初始化时检查屏幕大小
    window.addEventListener('resize', this.checkScreenSize);
    this.isWeChant = this.isWeChatBrowser();
  },
  created() {
    const id = this.$route.params.id || this.$route.query.id;
    this.id = id;
    this.fetchDataById(id);
    this.operationOne();
  },
  beforeDestroy() {
    this.removeFAQPageSchema();
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    removeFAQPageSchema() {
      const faqSchema = document.getElementById("faqpage-schema");
      if (faqSchema) {
        faqSchema.remove();
      }
    },

    stripHtml(html) {
      if (!html) return "";

      const div = document.createElement("div");
      div.innerHTML = html;

      return (div.textContent || div.innerText || "")
        .replace(/\s+/g, " ")
        .trim();
    },

    isFAQContent(title, content, beforefont) {
      const titleText = title || "";
      const contentText = this.stripHtml(content || "");
      const keywordText = beforefont || "";
      const allText = `${titleText} ${contentText} ${keywordText}`;

      // 标题或内容像问题
      const questionPattern = /[？?]|多少钱|多少费用|怎么收费|需要哪些|需要什么|需要多久|多久|几天|几个人|能不能|可以吗|能注册吗|怎么注册|怎么办理|如何办理|有哪些要求|有什么要求|需要到场吗|能代办吗|要交多少税|交多少税/;

      // 财税、工商、注册、代理记账相关关键词
      const businessPattern = /代理记账|注册公司|营业执照|注册地址|工商代办|工商变更|税务变更|公司注销|一般纳税人|小规模|开发票|法人|股东|报税|税收|税务|许可证|资质|商标注册|社保托管|高新|审计/;

      // 明显新闻类内容
      const articlePattern = /通知|公告|新闻|动态|资讯|政策解读|活动|发布|上线|升级|案例|行业|趋势|报告|提醒|名单|会议|培训|节日|放假/;

      if (articlePattern.test(titleText) && !/[？?]/.test(titleText)) {
        return false;
      }

      return questionPattern.test(allText) && businessPattern.test(allText);
    },

    addFAQPageSchema(title, content, id) {
      const answerText = this.stripHtml(content);

      if (!title || !answerText) {
        return;
      }

      this.removeFAQPageSchema();

      const pageUrl = `https://mingqicaiwu.com/news/${encodeURIComponent(id)}`;

      const schema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "@id": `${pageUrl}#faq`,
        "url": pageUrl,
        "mainEntity": [
          {
            "@type": "Question",
            "name": title,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": answerText
            }
          }
        ]
      };

      const script = document.createElement("script");
      script.id = "faqpage-schema";
      script.type = "application/ld+json";
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    },

    handleFAQPageSchema(data, id) {
      this.removeFAQPageSchema();

      if (this.isFAQContent(data.title, data.content, data.beforefont)) {
        this.addFAQPageSchema(data.title, data.content, id);
      }
    },

    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768; // 根据屏幕宽度判断是否是移动端
    },
    isWeChatBrowser() {
      const userAgent = navigator.userAgent.toLowerCase();
      return userAgent.indexOf("micromessenger") !== -1;
    },
    operationTwo() {
      let shareDesc = this.formatDescription(this.formattedContent);
      // let shareImg = this.extractImageSrc(this.formattedContent);
      let shareImg = this.shareImg;
      const shareLink = window.location.href.split("#")[0];
      const shareTitle = this.title;

      this.getWechatConfig(shareLink)
        .then((msg) => {
          this.configureWx(msg, shareLink, shareTitle, shareDesc, shareImg);
        })
        .catch((error) => {
          console.error("请求失败:", error);
        });
    },

    // 提取文本描述，处理HTML标签
    formatDescription(content) {
      if (!content) return "";
      const text = content.replace(/<[^>]*>/g, "");
      return text.substring(0, 20) + (text.length > 20 ? "..." : "");
    },

    // 提取分享图片
    extractImageSrc(content) {
      if (!content) return "";
      try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(content, "text/html");
        const img = doc.querySelector("img");
        return img ? img.src : "";
      } catch (e) {
        console.error("图片解析失败", e);
        return "";
      }
    },

    // 获取微信配置
    getWechatConfig(url) {
      return getWechatSignature(url);
    },

    // 配置微信分享
    configureWx(msg, shareLink, shareTitle, shareDesc, shareImg) {
      wx.config({
        debug: false,
        appId: this.appId,
        timestamp: msg.timestamp,
        nonceStr: msg.nonceStr,
        signature: msg.signature,
        jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"],
      });

      wx.ready(() => {
        console.log("ready方法执行");

        // 分享给微信好友
        wx.updateAppMessageShareData({
          title: shareTitle,
          desc: shareDesc,
          link: shareLink,
          imgUrl: shareImg,
          success: () => {
            console.log("updateAppMessageShareData执行成功");
          },
          cancel: () => {
            console.error("分享取消！");
          },
        });

        // 分享到朋友圈
        wx.updateTimelineShareData({
          title: shareTitle,
          link: shareLink,
          imgUrl: shareImg,
          success: () => {
            console.log("分享成功！");
          },
          cancel: () => {
            console.error("分享取消！");
          },
        });
      });

      // 全局错误监听
      wx.error(function (res) {
        console.log("res:", res);
      });
    },
    async operationOne() {
      try {
        const base64String = await generateShareCode(
          window.location.href.split("#")[0]
        );
        // 确保获取到 img 元素
        const shareImg = document.getElementById("shareImg");
        if (shareImg) {
          // 确保 base64String 以合适的格式开头
          shareImg.src = "data:image/png;base64," + base64String;
        } else {
          console.error("未找到 shareImg 元素");
        }
      } catch (error) {
        // alert("发生错误: " + error);
        console.log("操作错误", error);
      }
    },
    async getDefaultTitle() {
      try {
        const data = await getNewsDetail(this.id);
        return data.title;
      } catch (error) {
        console.error("查询出错，原因是", error);
      }
    },
    async fetchTwoId(id) {
      // 根据 id 查询数据的逻辑
      try {
        const data = await getNewsSibling(id);
        if (data.previousId != null) {
          this.previousId = data.previousId.id;
          this.previousTitle = data.previousId.title;
        }
        if (data.nextId != null) {
          this.nextId = data.nextId.id;
          this.nextTitle = data.nextId.title;
        }
        this.operationTwo();
      } catch (error) {
        console.error("查询出错，原因是", error);
      }
    },
    async fetchPathPreviousId(id) {
      // 根据 id 查询数据的逻辑
      try {
        const data = await getNewsSibling(id);
        // console.log("前一页和后一页data",data);
        this.handleClick(id, data.nextId, data.previousId);
      } catch (error) {
        console.error("查询出错，原因是", error);
      }
    },
    handleClick(id) {
      const contentPageUrl = this.$router.resolve({ name: "news-detail", params: { id } }).href;

      window.location = contentPageUrl;
    },
    async fetchPathNextId(id) {
      // 根据 id 查询数据的逻辑
      try {
        const data = await getNewsSibling(id);
        this.handleClick(id, data.nextId, data.previousId);
        // console.log("前一页和后一页data", data);
      } catch (error) {
        console.error("查询出错，原因是", error);
      }
    },
    async fetchDataById(id) {
      // 根据 id 查询数据的逻辑
      try {
        const data = await getNewsDetail(id);
        document.title = data.title;
        this.title = data.title;
        this.formattedContent = data.content;
        this.beforefont = data.beforefont;

        this.handleFAQPageSchema(data, id);

        this.fetchTwoId(id);
      } catch (error) {
        console.error("查询出错，原因是", error);
        this.removeFAQPageSchema();
      }
    },
    pathIndex() {
      this.$router.push("/");
    },
    pathRemen() {
      this.$router.push("/remen");
    },
    pathCompanyReg() {
      this.$router.push("/zhuce");
    },
    pathJizhang() {
      this.$router.push("/jizhang");
    },
    pathgongshang() {
      this.$router.push("/gongshang");
    },
    pathshuiwu() {
      this.$router.push("/shuiwu");
    },
    pathzhichan() {
      this.$router.push("/zhichan");
    },
    pathxuke() {
      this.$router.push("/xuke");
    },
    pathrenshi() {
      this.$router.push("/renshi");
    },
    pathxueyuan() {
      this.$router.push("/xueyuan");
    },
    pathxinxi() {
      this.$router.push("/xinxi");
    },
    pathcontact() {
      this.$router.push("/contact");
    },
    pppopco() {
      this.$root.ppp.ppp = !this.$root.ppp.ppp;
    },
  },
};
</script>

<style>
.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}

.el-carousel__button {
  background-color: #000 !important;
}

.el-menu-item.is-active {
  background-color: #b30101 !important;
}

.el-menu--horizontal>.el-menu-item {
  float: left;
  height: 45px !important;
  line-height: 45px !important;
  margin: 0;
}

@media (max-width: 768px) {
  .el-menu--horizontal>.el-menu-item {
    float: left;
    height: 30px !important;
    line-height: 30px !important;
    margin: 0;
  }

  .responsive-carousel el-carousel el-carousel--horizontal {
    height: 128px !important;
  }

  .el-carousel__indicators el-carousel__indicators--horizontal {
    margin-top: 15px !important;
  }

  .el-pager li {
    padding: 0 0px !important;
    min-width: 25.5px !important;
  }
}
</style>

<style scoped>
/* 面包屑 */
.tiaozhuan {
  text-align: left;
  font-size: 14px;
  margin-bottom: 20px;
  font-weight: 400;
  color: #6b7280;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.crumb-link {
  color: #6b7280;
  text-decoration: none;
  transition: color 0.2s;
}

.crumb-link:hover {
  color: #b30101;
}

.crumb-sep {
  margin: 0 10px;
  color: #c3c7ce;
}

.crumb-current {
  color: #b30101;
  font-weight: 600;
}

/* 页面主体 */
.margintop {
  margin-top: 118px;
  margin-left: 25%;
  margin-right: 25%;
}

.titlecss {
  font-size: 26px;
  font-weight: 700;
  color: #1f2329;
  line-height: 1.4;
  margin-bottom: 24px;
  padding-bottom: 18px;
  border-bottom: 2px solid #f0f1f3;
}

/* 关键词 */
.tagline {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin: 18px 0 24px;
  padding: 10px 16px;
  background: #faf7f6;
  border-left: 3px solid #c9746a;
  border-radius: 4px;
}

.tagline-label {
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 600;
  color: #b30101;
}

.tagline-text {
  font-size: 13px;
  color: #4b5563;
}

/* 上一篇 / 下一篇 */
.nav-prev-next {
  display: flex;
  gap: 16px;
  margin: 28px 0 20px;
}

.nav-card {
  flex: 1;
  padding: 16px 20px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #ffffff;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.nav-card:hover {
  border-color: #b30101;
  box-shadow: 0 6px 16px rgba(179, 1, 1, 0.10);
  transform: translateY(-2px);
}

.nav-card-label {
  font-size: 12px;
  font-weight: 600;
  color: #9ca3af;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}

.nav-card.next .nav-card-label {
  justify-content: flex-end;
}

.nav-card-label .nav-arrow {
  color: #c9746a;
  font-size: 14px;
}

.nav-card:hover .nav-card-label {
  color: #b30101;
}

.nav-card-title {
  font-size: 15px;
  color: #1f2329;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* 操作按钮区（返回首页 / 分享本文，同级别） */
.action-bar {
  display: flex;
  gap: 16px;
  justify-content: center;
  margin: 26px 0 34px;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 11px 34px;
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
  background: linear-gradient(135deg, #d22525 0%, #b30101 100%);
  border: none;
  border-radius: 999px;
  cursor: pointer;
  letter-spacing: 1px;
  transition: all 0.25s ease;
  box-shadow: 0 4px 12px rgba(179, 1, 1, 0.25);
}

.action-btn-icon {
  font-size: 16px;
  line-height: 1;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(179, 1, 1, 0.35);
}

/* 分享卡片 */
.share-card {
  margin-top: 8px;
  padding: 26px 32px 24px;
  border: 1px solid #ececee;
  border-top: 4px solid #b30101;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.06);
  text-align: center;
}

.share-card-header {
  margin-bottom: 18px;
}

.share-card-title {
  font-size: 18px;
  font-weight: 700;
  color: #1f2329;
  letter-spacing: 2px;
}

.share-card-body {
  display: inline-block;
  padding: 14px;
  border: 1px dashed #dcdde1;
  border-radius: 8px;
  background: #fbfbfc;
}

.share-qrcode {
  width: 200px;
  height: 200px;
  display: block;
  border-radius: 4px;
}

.share-card-tip {
  margin-top: 16px;
  font-size: 13px;
  color: #8a9099;
}

h1 {
  font-size: 0%;
}

h2 {
  font-size: 20px;
  font-weight: 400;
}

@media (max-width: 768px) {
  /* 其他 */

  .tiaozhuan {
    text-align: left;
    font-size: 11px;
  }

  .margintop {
    margin-top: 100px;
    margin-left: 2%;
    margin-right: 2%;
  }

  .nav-prev-next {
    flex-direction: column;
    gap: 12px;
  }

  .nav-card {
    padding: 13px 16px;
  }

  .nav-card.next .nav-card-label {
    justify-content: flex-end;
  }

  .action-bar {
    gap: 12px;
    margin: 20px 0 26px;
  }

  .action-btn {
    flex: 1;
    justify-content: center;
    padding: 11px 16px;
    font-size: 14px;
  }

  .share-card {
    padding: 20px 18px;
  }

  .share-qrcode {
    width: 160px;
    height: 160px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/xinwen.vue